const pendingDataReducer = (state = {}, action: { type: string, }) => {
    const { type } = action;

    const matches = /(.*)_(REQUEST|SUCCEEDED|FAILED)$/.exec(type);

    if (!matches) {
        return state;
    }

    const [, requestName, requestState] = matches;

    return {
        ...state,
        [requestName]: requestState === 'REQUEST',
    };
};

export default pendingDataReducer;
